import React, { useEffect, useState } from "react";
import '../Pages/EmployeeAdmin.css'
import axios from "axios";
import Moment from 'react-moment';
import SideBar from "../Components/SideBar";
import { useNavigate } from "react-router-dom";
import { ColorRing } from 'react-loader-spinner'
import AllSearch from "../Components/AllSearch";
import Pagination from "../Components/Pagination";
import Table from "../Components/Table";


const AllEmployer = ({ setUser }) => {

    const [TableUser, setTableUser] = useState([]);
    const [Loader, setLoader] = useState(true);
    const [Input, setInput] = useState('');
    const [CurrentPage, setCurrentPage] = useState(1);
    const DataPerPage = 10;

    const SearchResult = TableUser.filter((users) => users.name && users.name.toLowerCase().includes(Input.toLowerCase()));

    const firstIndex = (CurrentPage - 1) * DataPerPage;
    const endIndex = firstIndex + DataPerPage;
    const DisplayAllData = SearchResult.slice(firstIndex, endIndex);

    const navigate = useNavigate();


    useEffect(() => {
        const user = localStorage.getItem('user');
        if (user) {
            setUser(JSON.parse(user));
        }
    }, []);


    function handleSignOut() {
        localStorage.removeItem("admintoken");
        localStorage.removeItem("adminuser");
        setUser(null);
        navigate('/');
    }

    const handleChange = (e) => {
        e.preventDefault();
        const value = e.target.value;
        setInput(value);
    }

    const GetToken = localStorage.getItem("admintoken");

    const getTableData = () => {

        axios.get(`https://gojob-x5qp.onrender.com/api/admin/allemployer?page=${CurrentPage}&limit=${DataPerPage}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': GetToken
                }
            }
        )
            .then(response => {
                setTableUser(response.data.info);
                setLoader(false);
            })
    }




    useEffect(() => {
        getTableData();
    }, [CurrentPage]);


    return (
        <>
            <header className="navbar navbar-dark sticky-top bg-primary flex-md-nowrap p-0 shadow">
                <a className="navbar-brand col-md-3 col-lg-2 me-0 px-3" href="##">
                    <img src="img/Gojob.png" alt="" width={70} height={35} />
                </a>
                <button
                    className="navbar-toggler position-absolute d-md-none collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#sidebarMenu"
                    aria-controls="sidebarMenu"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon" />
                </button>
                <div class="navbar-nav">
                    <div class="nav-item text-nowrap">
                        <button className="btn btn-light" onClick={handleSignOut}>
                            Sign out
                        </button>
                    </div>
                </div>
            </header>

            <SideBar />


            <div className="loader-center text-center">
                {
                    Loader ? <ColorRing
                        visible={true}
                        height="80"
                        width="80"
                        ariaLabel="blocks-loading"
                        wrapperStyle={{}}
                        wrapperClass="blocks-wrapper"
                        colors={['black']}
                    />
                        : null
                }
            </div>

            <div className="container search-bar mt-4">
                <div className="row">
                    <div className="col-md-3"></div>
                    <div className="col-md-6">
                        <AllSearch
                            Input={Input}
                            setInput={setInput}
                            handleChange={handleChange}
                        />
                    </div>
                    <div className="col-md-3"></div>
                </div>
            </div>


            <div className="container data-table">
                <div className="table-responsive">
                    <Table DisplayAllData={DisplayAllData} />
                    <Pagination
                        CurrentPage={CurrentPage}
                        setCurrentPage={setCurrentPage}
                        SearchResult={SearchResult}
                        DataPerPage={DataPerPage}
                    />
                </div>
            </div>
        </>
    );
};

export default AllEmployer;
